<template>
  <div v-loading="loading" v-if="question.isShow" class="question-item">
    <div class="question-title">
      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <div class="qs-img-preview">
      <img :src="question.pictureUrl" alt="">
    </div>
    <div class="question-option">
      <div class="option-title">
        <el-select size="small" @change="changeHandler" v-model="question.value" placeholder="请选择" clearable>
          <el-option
              v-for="item in question.options"
              :key="item.id"
              :label="item.optionTitle"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'question-dropDown',
  props: {
    question: {required: true},
    displaySetting: {required: true},
    jumpSetting: {required: true},
    questionList: {required: true},
    patientId: {required: true}

  },
  data() {
    return {
      loading: false,
      currentIndex: null,
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'currentPage'
    ])
  },
  mounted() {
    this.getAnswer()
    this.getPicture()

  },
  beforeDestroy() {
    // console.log(this.currentPage, this.question.pageNumber);
    // if(this.$route.path == '/callPatient' && this.currentPage == this.question.pageNumber) {
    //   console.log('destory');
    //   this.deleteAnswer()
    //   this.disabledShowOrHide(this.currentIndex, false)
    // }
  },
  watch: {
    'question.isShow': {
      handler(val, oldVal) {
        //console.log(val)
        if (!val && oldVal) {
          this.disabledShowOrHide(this.currentIndex, false)
          this.question.value = ''
          this.currentIndex = null
        } else {
          this.getAnswer()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getPicture() {
      if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },
    changeHandler(value) {
      // console.log(value)
      var index = this.question.options.findIndex(item => item.id == value)
      // console.log(this.currentIndex, index + 1)
      if (this.currentIndex) {
        this.disabledShowOrHide(this.currentIndex, false)
        this.disabledShowOrHide(index + 1, true)
        if (this.currentIndex == index + 1) {
          this.disabledShowOrHide(this.currentIndex, false)
        }
      } else {
        this.disabledShowOrHide(index + 1, true)
      }
      this.question['valueAfter'] = this.question.options.find(item => item.id == value)
      // this.saveAnswer()
      this.currentIndex = index + 1
    },
    selectHandler(item, index) {
      // console.log(this.currentIndex, index + 1)
      if (this.currentIndex) {
        this.disabledShowOrHide(this.currentIndex, false)
        this.disabledShowOrHide(index + 1, true)
        if (this.currentIndex == index + 1) {
          this.disabledShowOrHide(this.currentIndex, false)
        }
      } else {
        this.disabledShowOrHide(index + 1, true)
      }
      this.question.value = item
      this.question['valueAfter'] = this.question.options.find(item => item.id == this.question.value)
      if (item.selected) {
        this.currentIndex = index + 1
      } else {
        this.currentIndex = null
      }
    },
    // disabledShowOrHide(index, boolean) {
    //     var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
    //         return it.questionId
    //     })
    //     disabledList.forEach(v => {
    //         if (this.questionList.find(item => item.id == v)) {
    //             this.questionList.find(item => item.id == v).isShow = boolean
    //         }
    //     })
    // },
    disabledShowOrHide(index, boolean) {
      // console.log(index)
      var disabledList = this.displaySetting.filter(item => item.optionId == index).map(it => {
        return it.questionId
      }).flat(9) //平铺数组 兼容处理
      if (disabledList) {
        disabledList.forEach(v => {
          // console.log(v)
          if (this.questionList.find(item => item.id == v)) {
            this.questionList.find(item => item.id == v).isShow = boolean
          }
        })
      }
    },
    checkIsFill() {
      if (this.question.isShow) {
        if (this.question.isMust) {
          if (this.question.value) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    getAnswer() {
      this.displaySetting.map(item => {
        if (item.newOptionId) {
          item.optionId = this.question.options.findIndex(_it => _it.id == item.newOptionId) + 1
          return item
        }
      })
      if (this.question.value) {
        if (Object.prototype.toString.call(this.question.value) == '[object Number]') {
          this.question.value = this.question.value

        } else {
          var optionIndex = this.question.options.findIndex(item => item.id == this.question.value.id)
          // console.log('optionIndex', this.question.options[optionIndex])
          this.currentIndex = optionIndex + 1
          this.question.options[optionIndex] = this.question.value
          this.disabledShowOrHide(optionIndex + 1, true)
          if (this.jumpSetting.length) {
            // console.log(this.jumpSetting.find(item => item.optionId == optionIndex + 1))
            if (this.jumpSetting.find(item => item.optionId == optionIndex + 1)) {
              var questionId = this.jumpSetting.find(item => item.optionId == optionIndex + 1).questionId
              this.$store.dispatch('queryQuestionPageListAsync', {
                questionPageResp: {
                  questionInfoId: questionId,
                  questionnaireNewId: this.question.questionnaireNewId
                }
              })
                  .then(res => {
                    this.jumpPageNumber = res.retValue[0].pageNumber
                    this.$emit('setJump', this.jumpPageNumber)
                  })
            }

          }
          this.question.value = this.question.value.id
          this.question.valueAfter = this.question.options.find(item => item.id == this.question.value)
          this.show = true
        }

        //如果有跳转逻辑
        // this.question.options.find(item => item.id == this.question.value.id).selected = true
      }
    },
    saveAnswer() {
      this.loading = true
      return new Promise((resolve => {
        var selectAnswer
        if (this.question.value) {
          selectAnswer = this.question.options.find(item => item.id == this.question.value)
        } else {
          selectAnswer = ""
        }
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: selectAnswer ? JSON.stringify(selectAnswer) : "",
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId,
          questionType: this.question.type || null,
        }
        if (this.$route.query.abnormal == '5') {
          params.isRecord = true
        } else {
          params.isRecord = false
        }
        if (this.question.patientAnswerInfoId) {
          this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {
                this.loading = false


                resolve()
              })
        } else {
          this.$store.dispatch('saveQuestionAnswer', params)
              .then((res) => {
                // console.log(res);
                this.loading = false
                this.question.patientAnswerInfoId = res.retValue.id

                // this.question.patientAnswerInfoId = res.retValue.id
                resolve()
              })
        }
        // console.log(params)
      }))
      // this.$store.dispatch('saveQuestionAnswer',)
    },
    deleteAnswer() {
      var params = {
        questionNewId: this.question.questionnaireNewId,
        answerInfoId: this.question.patientAnswerInfoId || null,
      }
      if (this.question.patientAnswerInfoId) {
        this.$store.dispatch('deleteQuestionAnswer', params)
            .then(res => {
              if (res.status == 0) {
                this.question.patientAnswerInfoId = null
                this.question.value = null
                this.question.answerInfo = null
              } else {
              }
            })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "questionCommon";

.question-option {
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start !important;

  .option-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .option-other {
  }
}


</style>